import React from "react";
import BaseAvatar from "./BaseAvatar";
import { formatInitials } from "./logic";
import { jsx as _jsx } from "react/jsx-runtime";
function Avatar(_ref) {
  var _ref$initials = _ref.initials,
    initials = _ref$initials === void 0 ? "" : _ref$initials,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "md" : _ref$size,
    color = _ref.color,
    imageSrc = _ref.imageSrc;
  return /*#__PURE__*/_jsx(BaseAvatar, {
    size: size,
    initials: formatInitials(initials),
    color: color,
    imageSrc: imageSrc
  });
}
export default Avatar;